import { CustomApplicantElement } from '../service-models/CustomApplicantElement';

export class EEOCFormModel extends CustomApplicantElement {
  
}
